/**
 *
 * Project settings - override any values from platform settingsDefaults here
 *
 */

import settingsDefault from '_platform/src/theme/settingsDefault';

const settings = {
  // -- Base Settings --
  siteName: 'Harman Rewards ',

  // -- Cloudinary Settings --
  // Cloudinary cloud name
  cloudinaryCloudName: 'incremental',

  // -- Rewards --
  // Hide reward category images (main rewards page)
  // rewardsCategoryHideImage: true,

  // Pages - must have trailing slash
  cartPage: '/cart/',
  privacyPage: '/privacy/',
  rewardsPage: '/rewards/',

  mobileAppSSOEnabled: true,

  // Delivery method "Client" label (usually Branch or Rep)
  deliveryMethodClientLabel: 'Rep',

  // Master override settings
  // cartDisabled: true,
  quickviewDisabled: true,
  //wishlistDisabled: true,

  // -- Default Overrides --

  // Minimum password character length
  minimumPasswordLength: 8,
  passwordRequirementMessage:
    'Passwords must be at least 8 characters long and must contain at least 1 digit and 1 lowercase letter.',

  // Important!: If the user is being redirected, ensure that the PrivateRoute
  // component has the `tempAuthAllowed` prop set, otherwise the user will not
  // be able to see/update their profile.
  // For futher documentation, see _platform/src/theme/settingsDefault.js
  // redirectOnIncompleteProfile: '/profile/',

  // Rewards page - disable category listing and display rewards on the main page
  rewardsCategorySkip: true,
};

// Note: If you are altering the breakpoints, make sure you loop over the
// values and create the media prop. See settingsDefault.js for implementation.

// Deep merge with default values
const settingsApp = { ...settingsDefault, ...settings };

export default settingsApp;
